import { useSelector } from 'react-redux';
import { useBidsHistoryOfferAuction } from '../hooks';
import NumberFormat from 'react-number-format';

export const EndingBid = ({ vehicle }) => {
  const amount = useBuyersEndingAmount(vehicle);
  if (!amount) {
    return 'N/A';
  }
  return <NumberFormat displayType="text" prefix="$" value={amount} thousandSeparator />;
};

const useBuyersEndingAmount = vehicle => {
  const user = useSelector(state => state.user.user);
  const offerAuction = useBidsHistoryOfferAuction(vehicle.id);

  if (!user) return null;

  if (vehicle.my_alternative_bid_offer) {
    return vehicle.my_alternative_bid_offer.amount;
  }

  const userOffer = offerAuction?.offerBids?.find(bid => bid.user_id === user.id);
  if (userOffer) {
    return userOffer.amount;
  }

  if (vehicle.my_bid) {
    return vehicle.my_bid.amount;
  }

  return null;
};
